import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputEmail, InputFile, InputMultiline, InputSelect, Layout, InputSwitch, InputPicklist } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './personalinfo-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import OwnerPicklist from '../owner/owner-picklist.component';
import PersonalinfotypePicklist from '../personalinfotype/personalinfotype-picklist.component';
import RegionPicklist from '../region/region-picklist.component';
import CivilnumberList from '../civilnumber/civilnumber-list.component';
import AddressList from '../address/address-list.component';
import DivisionPicklist from '../division/division-picklist.component';
import UserPicklistPersonalinfo from '../user/user-picklist-personalinfo.component';
import ScheduleChecklist from '../schedule/schedule-checklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
    caption?: string;
    personalinfotypeType?: string;
    userId?: number;
    disableAutoBack?: boolean;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
}

export default class PersonalinfoEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadPersonalinfotype = (data: any) => {
        this.state.datarow.personalinfotype.push({'id': data?.id});
        this.state.datarow.personalinfotype = this.state.datarow.personalinfotype.filter((d: any) => d.id !== this.state.datarow.personalinfotype)
        this.setState({ datarow: { ...this.state.datarow, 'personalinfotype': this.state.datarow.personalinfotype, 'personalinfotypeCaption': data?.name || '', 'personalinfotypeType': data?.type || 'customer'  }  });
    }
    
    private onLoadBirthplace = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'birthplace': data?.id, 'birthplaceCaption': data?.description || ''  }  });
    }

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{id:this.state.datarow.imageId, files: data, ref: Model.endPointMedia, field:'image'}}});
    }
    
    private onLoadDivision = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'division': data?.id, 'divisionCaption': data?.name || ''  }  });
    }
    
    private onLoadSchedule = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'schedule': data || [], 'scheduleCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    } 
    
    private onLoadUser = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'user': data?.id, 'userCaption': data?.name || ''  }  });
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} id={this.props.userId} caption={this.props.caption} 
                model={Model} endPointFilter={Model.endPointFilter2(this.props.personalinfotypeType, this.props.userId)} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onLoad={this.onLoad} onError={this.onError} disableAutoBack={this.props.disableAutoBack} disableCard>              

                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                        <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange} readOnly={!!this.props.userId}/>
                        <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                        {AppService.isAppFullVersion() &&
                        <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                            <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                        </InputPicklist> 
                        }            
                        {!this.props.userId &&
                        <InputPicklist name='personalinfotype' label='Type' value={this.state.datarow.personalinfotype} caption={this.state.datarow.personalinfotypeCaption} error={this.state.errors?.personalinfotypeId} onChange={this.onChange} >
                            <PersonalinfotypePicklist currentId={this.state.datarow.personalinfotype} type={this.props.personalinfotypeType} onLoad={this.onLoadPersonalinfotype}/>
                        </InputPicklist>          
                        } 
                        <Input name='phone' label='Phone' value={this.state.datarow.phone} error={this.state.errors?.phone} onChange={this.onChange} />
                        <InputEmail name='email' label='Email' value={this.state.datarow.email} error={this.state.errors?.email} onChange={this.onChange} />
                        <InputPicklist name='birthplace' label='Place of Birth' value={this.state.datarow.birthplace} caption={this.state.datarow.birthplaceCaption} error={this.state.errors?.birthplace} onChange={this.onChange} >
                            <RegionPicklist history={this.props.history} caption='Select Place of Birth' currentId={this.state.datarow.birthplace} regionType='city' onLoad={this.onLoadBirthplace}/>
                        </InputPicklist>  
                        <InputDate name='birthdate' label='Date of Birth' value={this.state.datarow.birthdate} error={this.state.errors?.birthdate} onChange={this.onChange} disableTime/>
                        <InputSelect name='gender' label='Gender' value={this.state.datarow.gender} options={Model.optionGender} error={this.state.errors?.gender} onChange={this.onChange} />
                        <InputFile name='imageUrl' label='Photo' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                        {this.state.datarow.personalinfotypeType === 'employee' &&
                        <>
                        <InputPicklist name='division' label='Division' value={this.state.datarow.division} caption={this.state.datarow.divisionCaption} error={this.state.errors?.division} clearValue={this.onLoadDivision} onChange={this.onChange} >
                            <DivisionPicklist currentId={this.state.datarow.division} onLoad={this.onLoadDivision}/>
                        </InputPicklist>
                        <InputPicklist name='schedule' label='Schedule List' value={this.state.datarow.schedule} caption={this.state.datarow.scheduleCaption} disableAutoClose clearValue={this.onLoadSchedule} error={this.state.errors?.schedule} onChange={this.onChange} >
                            <ScheduleChecklist history={this.props.history} currentId={this.state.datarow.schedule} onLoad={this.onLoadSchedule} disableBackButton/>
                        </InputPicklist>
                        </>
                        }
                        {!this.props.userId &&
                        <InputPicklist name='user' label='User' value={this.state.datarow.user} caption={this.state.datarow.userCaption} error={this.state.errors?.user} clearValue={this.onLoadUser} onChange={this.onChange} >
                            <UserPicklistPersonalinfo currentId={this.state.datarow.user} onLoad={this.onLoadUser}/>
                        </InputPicklist>
                        }
                    </>
                    },

                    {caption: 'Addresses', child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <AddressList history={this.props.history} root={this.props.root} parentId={this.state.datarow.id} disableBackButton disableCard/>
                    },

                    {caption: 'Civil Numbers', child: 
                    this.state.datarow.id > 0 && this.props.history &&
                        <CivilnumberList history={this.props.history} root={this.props.root} personalinfoId={this.state.datarow.id} disableBackButton disableCard/>
                    },

                    ]}
                />  

            </BaseEdit>
        );
    }
}